<template>
  <div id="history">
    <div class="col-lg-12 col-md-12 col-sm-12">
      <div class="body">
        <!-- 일단 주석 (삭제x)
        <div class="input-group search" style="margin-bottom: 30px">
          <input
            type="text"
            class="form-control"
            placeholder="Search here..."
          />
          <div class="input-group-append">
            <span class="input-group-text"
              ><i class="zmdi zmdi-search"></i
            ></span>
          </div>
        </div> -->
        <h4>{{ workflowStore.nowWorkName }}</h4>
        <div class="table-responsive">
          <table class="table" id="hitoryTabl">
            <thead>
            <tr>
              <th>#</th>
              <!--              <th>&nbsp;</th>-->
              <th>이름</th>
              <th>실행횟수</th>
              <th>마지막 실행일</th>
            </tr>
            </thead>
            <tbody v-if="workflows.length > 0">
            <tr v-for="(list, index) in workflows" :key="index">
              <th>{{ index + 1 }}</th>
              <!--              <th>-->
              <!--                <div>-->

              <!--                  &lt;!&ndash;                  이미지 가지고 오는 부분 추가... 하기 &ndash;&gt;-->

              <!--                  <img-->
              <!--                    class="workIcon w60 rounded" alt="Rounded Image"-->
              <!--                    :src="imagePaths(list.startImage)"-->
              <!--                  />-->
              <!--                  &nbsp;-->
              <!--&lt;!&ndash;                  <i class="zmdi zmdi-forward"></i>&ndash;&gt;-->
              <!--                  <img-->
              <!--                    class="workIcon w60 rounded" alt="Rounded Image"-->
              <!--                    :src="imagePaths(list.endImage)"-->
              <!--                  />-->
              <!--                </div>-->
              <!--              </th>-->
              <td  @click="goHistoryDetail(index)">{{ list.workflowName }}</td>
              <td>{{ list.count }}</td>
              <td>{{ list.startTime }}</td>
            </tr>
            </tbody>
            <tbody v-else>
            <tr>
              <td colspan="5">실행 기록이 없습니다.</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div style="text-align: center;">
          <button type="button" class="btn btn-primary " v-if="this.skipNum > 0" @click="getPreviousPage">이전</button>
          <span v-for="num in Math.ceil(this.totalCount/this.pageNum)" :key="num">

              <button class="btn" v-if="num != skipNum + 1 && num < skipNum + 4 && num > skipNum - 4"  style="color: forestgreen" @click="skipToPage(num)">{{ num }}</button>
              <button type="button" class="btn" v-if="num == skipNum + 1" style="color: #00dd3a" @click="skipToPage(num)">{{ num }}</button>
        </span>
          <!--{{Math.floor(this.totalCount/this.pageNum)}}-->
          <button type="button" class="btn btn-primary " v-if="this.workflows.length == 20 && this.pageNum * this.skipNum + 20 < this.totalCount" @click="getNextPage">다음</button>

        </div>

      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: 'HistoryPage',
  components: {

  },
  data() {
    return {
      workflows: [],

      pageNum : 20,
      skipNum : 0,
      totalCount : 0,
    }
  },
  methods: {
    skipToPage(num) {
      this.skipNum = num-1;

      this.getTempList();

    },
    countingIndex(index) {

      return this.skipNum * this.pageNum + index + 1;


    },
    getPreviousPage() {
      this.skipNum = this.skipNum - 1;

      this.getTempList();
    },
    getNextPage() {
      this.skipNum = this.skipNum + 1;

      this.getTempList();

    },
    goHistoryDetail(index) {

      console.log("code : ", this.workflows[index].workflowCode)

      this.$store.state.workflowStore.workflowCode =  this.workflows[index].workflowCode


      // var param = { workflowCode: list.workflowCode }
      // this.api.getWorkflowHistoryDetail(param).then((res) => {
      //   console.log("getWorkflowHistoryDetail res : ", res);
      //   if (res["code"] == 0) {
      //
      //     var dList = res.list;
      //
      //     if (dList != undefined) {
      //
      //       for (var i = 0; i < dList.length; i++) {
      //
      //         var schema = JSON.parse(dList[i].workflowSchema);
      //
      //         if (schema.workflows[0].api.appImage != undefined) {
      //           dList[i].startImage = schema.workflows[0].api.appImage;
      //         }
      //         if (schema.workflows[schema.workflows.length - 1].api.appImage != undefined) {
      //           dList[i].endImage = schema.workflows[schema.workflows.length - 1].api.appImage;
      //         }
      //
      //       }
      //
      //     }
      //
      //
      //     this.$store.dispatch("saveWorkflowDetailHistory", list);
      //     this.$store.dispatch("saveWorkflowDetailHistorys", dList);
      //
      //   }
      // });

      // this.api.getApiHistory(param).then((res) => {
      //   console.log("getApiHistory res : ", res);
      //   if (res["code"] == 0) {
      //
      //     this.$store.dispatch("saveApiHistorys", res.list);
      //
      //   }
      // });


      this.$router.push({ name: "HistoryDetailPage", params:{title : this.workflows[index].workflowName} });

    },

    imagePaths(value) {
      if (value != null && value != "") {
        return (
          "https://frients-smartservice.s3.ap-northeast-2.amazonaws.com/" +
          value
        );
      } else {
        return "https://frients-smartservice.s3.ap-northeast-2.amazonaws.com/common/noimage.jpg";
      }
    },
    historyLogList(){
      var param = {
        userCode: this.$store.getters.getUserCode,
        pageNum : this.pageNum,
        skipNum : this.skipNum
      };

      this.api.getWorkflowHistory(param)
        .then((res) => {
          console.log(res);

          if(this.utils.preApiHandle(res)) {

            console.log("dev front page res : ", res)
          }

          this.totalCount = res.totalCount;

          var list = res.list;

          // if (res.list != undefined) {
          //
          //   for (var i = 0; i < list.length; i++) {
          //
          //     var schema = JSON.parse(list[i].workflowSchema);
          //
          //     if (schema.workflows[0].api.appImage != undefined) {
          //       list[i].startImage = schema.workflows[0].api.appImage;
          //     }
          //     if (schema.workflows[schema.workflows.length - 1].api.appImage != undefined) {
          //       list[i].endImage = schema.workflows[schema.workflows.length - 1].api.appImage;
          //     }
          //
          //   }
          //
          // }

          this.workflows = list;

        });
    }
  },
  computed: {
    workflowStore() {
      return this.$store.state.workflowStore;
    },
    userStore() {
      return this.$store.state.userStore;
    }
  },
  created() {
    console.log('HistoryPage created')
    this.historyLogList();
  },
  mounted() {
    console.log('HistoryPage created')
  },
  beforeDestroy() {
    console.log('HistoryPage beforeDestroy')
  }
}
</script>

